// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_stroke1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M22 22L2 2","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"work-off","clipPath":"url(#clip0_543_8211)"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14.001 7.50198H13.001L13 7.50098L14.001 7.50198ZM14.001 7.50198L21 7.501V14.501M21 14.501V15.501L21.001 15.502L21 14.501ZM8.5 3.5H15.5V7.5M8.5 3.5L8.5 3.67297L8.49902 3.67197L8.5 3.5ZM3 7.5H7.5L20.5 20.5H3V7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","mask":"props.overlapMaskUrl_stroke1"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22 22L2 2","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WorkOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'work-off',
    ref,
    icon: element,
  },
));

WorkOffIcon.displayName = 'WorkOffIcon';

export default WorkOffIcon;
